import { render } from "./ViewArticle.vue?vue&type=template&id=1339de54&scoped=true"
import script from "./ViewArticle.vue?vue&type=script&lang=js"
export * from "./ViewArticle.vue?vue&type=script&lang=js"

import "./ViewArticle.vue?vue&type=style&index=0&id=1339de54&scoped=true&lang=scss"
import "./ViewArticle.vue?vue&type=style&index=1&id=1339de54&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1339de54"]])

export default __exports__